var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSimplify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg957",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs961"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath971"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path969"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g963",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g967",
    clipPath: "url(#clipPath971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g973",
    transform: "translate(507.9658,266.2349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -140,150 c -9.289,9.953 -25.966,3.379 -25.966,-10.235 v -45 h -80.787 l -115.606,115.607 c -2.813,2.813 -6.628,4.393 -10.607,4.393 h -120 c -8.284,0 -15,-6.716 -15,-15 0,-8.284 6.716,-15 15,-15 h 113.787 L -263.573,69.159 c 2.813,-2.814 6.629,-4.394 10.607,-4.394 h 102 c 8.284,0 15,6.716 15,15 V 101.71 L -31.484,-10.235 -135.966,-122.18 v 21.945 c 0,8.284 -6.716,15 -15,15 h -102 c -3.978,0 -7.794,-1.58 -10.607,-4.393 l -115.606,-115.607 h -113.787 c -8.284,0 -15,-6.716 -15,-15 0,-8.284 6.716,-15 15,-15 h 120 c 3.979,0 7.794,1.581 10.607,4.394 l 115.606,115.606 h 80.787 v -45 c 0,-13.614 16.677,-20.187 25.966,-10.235 l 140,150 C 5.379,-14.707 5.379,-5.763 0,0",
    style: {
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path975"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g977",
    transform: "translate(15,241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 203.787 l -14.394,-14.394 c -5.858,-5.857 -5.858,-15.355 0,-21.212 5.858,-5.859 15.356,-5.859 21.213,0 l 40,40 c 5.858,5.857 5.858,15.355 0,21.212 l -40,40 c -5.857,5.859 -15.355,5.859 -21.213,0 -5.858,-5.857 -5.858,-15.355 0,-21.212 L 203.787,30 H 0 C -8.284,30 -15,23.284 -15,15 -15,6.716 -8.284,0 0,0",
    style: {
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path979"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g981",
    transform: "translate(0,366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.284 6.716,-15 15,-15 h 93.787 L 94.393,-29.394 c -5.858,-5.857 -5.858,-15.355 0,-21.212 v -10e-4 c 5.858,-5.858 15.356,-5.858 21.213,0 l 40,40.001 c 5.858,5.857 5.858,15.355 0,21.212 l -40,40.001 c -5.857,5.858 -15.355,5.858 -21.213,0 v -10e-4 c -5.858,-5.857 -5.858,-15.355 0,-21.212 L 108.787,15 H 15 C 6.716,15 0,8.284 0,0",
    style: {
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path983"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g985",
    transform: "translate(15,131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 93.787 L 79.393,-14.394 c -5.858,-5.857 -5.858,-15.355 0,-21.212 v -10e-4 c 5.858,-5.858 15.356,-5.858 21.213,0 l 40,40.001 c 5.858,5.857 5.858,15.355 0,21.212 l -40,40.001 c -5.857,5.858 -15.355,5.858 -21.213,0 v -0.001 c -5.858,-5.857 -5.858,-15.355 0,-21.212 L 93.787,30 H 0 C -8.284,30 -15,23.284 -15,15 -15,6.716 -8.284,0 0,0",
    style: {
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path987"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSimplify);
export default __webpack_public_path__ + "static/media/icon-simplify.f0b0330016350b57e1b9d56020e3d249.svg";
export { ForwardRef as ReactComponent };